import * as React from 'react'

export function Contact(props: {}){


   return <div className="max-w-3xl m-auto landing p-4"> 
        <div style={{ fontFamily: 'Dancing Script' }} className="text-blue-500 text-5xl font-normal w-full text-center pb-2">Contact Info</div>

        <figure className=" shadow-lg mb-5 md:flex bg-slate-100 rounded-xl p-8 md:p-0 ">
            <div className="pt-6 md:p-8 text-center md:text-left space-y-4">
                <blockquote className="text-2xl font-normal">
                    <img className="w-24 float-left mr-3 -rotate-12" src={`/images/first2.png`}></img>
                    <p>If you would like a pattern, have questions, or need help, please send an e-mail to Sheri at  <a className="text-blue-500" href = "mailto: DiapersforHaiti@outlook.com"> DiapersforHaiti@outlook.com</a>.</p> 
                </blockquote>
            </div>
        </figure>
   </div>
}